import { PriceChange, TokenBalanceResponse, TokenDataResponse, SymbolInfoResponse, TokenAvailabilityResponse, Ticker24hResponse } from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Market data API functions
 */

export const getPriceChanges = async (
  userId: string,
  symbol: string,
  timestamp: number,
  interval: '1m' | '5m' | '15m' | '30m' | '1h' | '4h' | '1d' = '1m',
  limit: number = 15
): Promise<PriceChange[]> => {
  return ApiClientManager.getMarketDataClient().getPriceChanges(userId, symbol, timestamp, interval, limit);
};

export const getPriceChangesForPeriod = async (
  userId: string,
  symbol: string,
  startTime: number,
  endTime: number,
  interval: '1m' | '5m' | '15m' | '30m' | '1h' | '4h' | '1d' = '1m',
  padding: number = 10
): Promise<PriceChange[]> => {
  return ApiClientManager.getMarketDataClient().getPriceChangesForPeriod(userId, symbol, startTime, endTime, interval, padding);
};

export const getTokenData = async (
  userId: string,
  symbol: string,
  exchangeCode?: string
): Promise<TokenDataResponse | null> => {
  return ApiClientManager.getMarketDataClient().getTokenData(userId, symbol, exchangeCode);
};

export const get24hTicker = async (
  userId: string,
  symbol: string,
  exchangeCode?: string
): Promise<Ticker24hResponse | null> => {
  return ApiClientManager.getMarketDataClient().get24hTicker(userId, symbol, exchangeCode);
};

export const getTokenBalance = async (
  userId: string,
  symbol: string
): Promise<TokenBalanceResponse | null> => {
  return ApiClientManager.getMarketDataClient().getTokenBalance(userId, symbol);
};

export const getSymbolInfo = async (
  userId: string,
  symbol: string,
  exchangeCode?: string
): Promise<SymbolInfoResponse | null> => {
  return ApiClientManager.getMarketDataClient().getSymbolInfo(userId, symbol, exchangeCode);
};

export const getTokenAvailability = async (
  userId: string,
  symbol: string
): Promise<TokenAvailabilityResponse | null> => {
  return ApiClientManager.getMarketDataClient().getTokenAvailability(userId, symbol);
};

